<template>
  <FormContainer>
    <template #title>Détails complémentaires</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_7a"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-9 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_7b"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-9 col-md-8 col-sm-36"
          disabled
        />
        <WrapperDropdown
          :model-value="model?.typePublic"
          :items="typePublicItems"
          disabled
          label="Type de public"
          class="col-9 col-md-10 col-sm-36"
        />
        <WrapperInputNumber
          v-if ="estDossier"
          id="field_8"
          v-model="effectifModel"
          label="Effectif de l'entreprise"
          class="col-9 col-md-10 col-sm-36"
          :required="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.effectifTotalEntreprise?.$messageErreurDirty!"
          deletable
          :decimal="0"
          :readonly
          :disabled="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.NotPresent"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
import { typePublicItems } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey } = store
  const { meta, model, readonly, estDossier } = storeToRefs(store)

  const effectifModel = setupFieldWithKey<number>('employeur.effectifTotalEntreprise', true)
</script>
